export enum ENumberOf {
  No0 = '0',
  No1 = '1',
  No2 = '2',
  No3 = '3',
  No4 = '4',
  No5 = '5',
  MoreThan5 = '>5',
}
